import { render } from "./TacO.vue?vue&type=template&id=a61d9ea0"
const script = {}

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/package/TacO.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a61d9ea0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a61d9ea0', __exports__)) {
    api.reload('a61d9ea0', __exports__)
  }
  
  module.hot.accept("./TacO.vue?vue&type=template&id=a61d9ea0", () => {
    api.rerender('a61d9ea0', render)
  })

}


export default __exports__